import React from 'react';
import { CONS, DateUtils } from '@pomofocus/core';
import { globalActions, configActions, activityActions, 
// todoListActions,
projectActions, reportActions, paymentActions, userActions, userSelectors, timerActions, useAppDispatch, useAppSelector, } from '@pomofocus/shared-client';
import App from './App';
import { getActivities, getConfigObj, getTimerStateLocalDB, } from '../modules/IndexedDB';
// import accessTokenUtils from '../utils/AccessTokenUtils';
function returnBgColor(stage, darkMode, colorThemes) {
    if (darkMode)
        return 'black';
    return CONS.COLORS.THEME[colorThemes[stage]];
}
function AppContainer() {
    const dispatch = useAppDispatch();
    const darkMode = useAppSelector((state) => state.timer.darkMode);
    const stage = useAppSelector((state) => state.timer.stage);
    const viewHeight = Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
    const bgColor = useAppSelector((state) => state.global.bgColor);
    const authenticated = useAppSelector((state) => state.user.authenticated);
    const configObj = useAppSelector((state) => state.config.config);
    const isPremium = useAppSelector((state) => userSelectors.selectIsPremium(state));
    const changeBgColor = (_stage, _darkMode, colorThemes) => {
        const _bgColor = returnBgColor(_stage, _darkMode, colorThemes);
        dispatch(globalActions.changeBgColor({ bgColor: _bgColor }));
    };
    const readIndexedDB = async () => {
        const _configObj = await getConfigObj();
        dispatch(configActions.updateConfigObj(_configObj));
        // dispatch(reportActions.fetchDailyWorkMinutes());
        const activities = await getActivities();
        dispatch(activityActions.saveActivities({ todos: activities }));
        const { dateDigit } = DateUtils.convertDateToString(new Date());
        const { pomodoroCnt: _pomodoroCnt, selectedActivity: _selectedActivity, } = await getTimerStateLocalDB(Number(dateDigit));
        dispatch(timerActions.setPomodoroCnt(_pomodoroCnt));
        dispatch(activityActions.selectActivity({ id: _selectedActivity }));
    };
    const readMongoDB = () => {
        dispatch(configActions.fetchConfig());
        dispatch(activityActions.apiGetAllTodo());
        dispatch(activityActions.apiGetTodoTemplate());
        dispatch(projectActions.fetchAllProjects());
        const { dateDigit } = DateUtils.convertDateToString(new Date());
        dispatch(reportActions.getActivitySummary());
        dispatch(timerActions.loadTimerState({ dateDigit: Number(dateDigit) }));
    };
    const fetchStripeInfo = () => {
        dispatch(paymentActions.getStripeInfo());
    };
    // const fetchRootUrl = () => {
    //   dispatch(globalActions.fetchEnvConstants());
    // };
    const fetchUser = () => {
        dispatch(userActions.fetchUser());
    };
    const openModal = (modalName) => {
        dispatch(globalActions.changeVisibleModal({ visibleModal: modalName }));
    };
    return (React.createElement(App, { darkMode: darkMode, stage: stage, viewHeight: viewHeight, bgColor: bgColor, authenticated: authenticated, configObj: configObj, isPremium: isPremium, changeBgColor: changeBgColor, readIndexedDB: readIndexedDB, readMongoDB: readMongoDB, fetchStripeInfo: fetchStripeInfo, 
        // fetchRootUrl={fetchRootUrl}
        fetchUser: fetchUser, openModal: openModal }));
}
export default AppContainer;
